export default __webpack_public_path__ + "b346eafdbbd2fec7274bb03cbe610c85.svg";